//import ChunkUploader from './ChunkUploader'

export default () => {
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i]
      descriptor.enumerable = descriptor.enumerable || false
      descriptor.configurable = true
      if ('value' in descriptor) descriptor.writable = true
      Object.defineProperty(target, descriptor.key, descriptor)
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps)
    if (staticProps) _defineProperties(Constructor, staticProps)
    return Constructor
  }

  function postData(
    url,
    data,
    accessToken,
    apiKey,
    xIdToken = '',
    contentType = 'application/json'
  ) {
    // Default options are marked with *
    let headers = {
      accept: 'application/json, text/plain, */*',
      authorization: accessToken,
      'x-api-key': apiKey,
      'x-id-token': xIdToken,
    }
    if (contentType !== 'formData') {
      headers['content-type'] = contentType
      data = JSON.stringify(data)
    }
    return fetch(url, {
      headers: headers,
      referrerPolicy: 'no-referrer-when-downgrade',
      body: data,
      method: 'POST',
    }).then((response) => response.json())
  }

  if ('function' === typeof importScripts) {
    var ChunkUploader =
      /*#__PURE__*/
      (function () {
        function ChunkUploader({
          chunkSize = 2 * 1024 * 1024,
          startChunkUrl = '',
          endChunkUrl = '',
          chunkUploadUrl = '',
          postUploadProcessUrl = '',
          fileName = 'fileName.glb',
          metaData = {},
          fileapiKey = '',
          apiKey = '',
          xIdToken = '',
          render_job_id = '',
          render_comment_id = '',
          location = 'INTERNAL - India',
          projectName = 'CAD',
          asset_id = '',
          onfileUploadSuccess = () => {},
          onStartCallSuccess = () => {},
          accessToken = '',
          asset_type = '',
          file_type = '',
        }) {
          this.chunkSize = chunkSize
          this.file = ''
          this.name = fileName
          this.startChunkUrl = startChunkUrl
          this.endChunkUrl = endChunkUrl
          this.chunkUploadUrl = chunkUploadUrl
          this.postUploadProcessUrl = postUploadProcessUrl
          this.uploadId = ''
          this.render_job_id = render_job_id
          this.render_comment_id = render_comment_id
          this.fileapiKey = fileapiKey
          this.apiKey = apiKey
          this.metaData = metaData
          this.projectName = projectName
          this.location = location
          this.onfileUploadSuccess = onfileUploadSuccess
          this.onStartCallSuccess = onStartCallSuccess
          this.accessToken = accessToken
          this.xIdToken = xIdToken
          this.asset_id = asset_id
          this.asset_type = asset_type
          this.file_type = file_type
        }

        _createClass(ChunkUploader, [
          {
            key: 'initialize',
            value: function initialize(file) {
              this.file = file
              this.chunkCount = Math.ceil(file.size / this.chunkSize) || 1
              this.statusCallReqParams = {}

              this.uploadStartCall()
            }, // STEP 1
          },
          {
            key: 'uploadStartCall',
            value: function uploadStartCall() {
              var params = {}
              if (this.render_job_id !== '') {
                params.render_job_id = this.render_job_id
                params.render_comment_id = this.render_comment_id
              }
              if (this.asset_id !== '') {
                params.asset_id = this.asset_id
                params.file_name = this.name
                params.file_type = this.file_type
              }
              if (this.asset_type === 'PROP') {
                params.asset_type = this.asset_type
              }

              postData(
                this.startChunkUrl,
                params,
                this.accessToken,
                this.apiKey,
                this.xIdToken
              )
                .then((response) => {
                  if (response && !response.upload_id) return
                  this.uploadId = response.upload_id
                  this.uploadChunkLoop()
                })
                .catch((e) => {
                  console.log(e)
                })
            }, // STEP 2
          },
          {
            key: 'uploadChunkLoop',
            value: function uploadChunkLoop() {
              var completedCount = 0 // chunking of files

              for (var i = 0; i < this.chunkCount; i++) {
                var chunkedFormData = new FormData()
                var req = {
                  upload_id: this.uploadId,
                  file_name: this.name,
                  chunk_number: i,
                  total_number_of_chunks: this.chunkCount,
                  chunk_size: this.chunkSize,
                }
                if (this.render_job_id !== '') {
                  req.render_comment_id = this.render_comment_id
                }
                if (this.asset_id !== '') {
                  req.asset_id = this.asset_id
                }
                if (this.asset_type === 'PROP') {
                  req.asset_type = this.asset_type
                }

                chunkedFormData.append(
                  'chunkUploadRequest',
                  new Blob([JSON.stringify(req)], {
                    type: 'application/json',
                  })
                )
                chunkedFormData.append(
                  'file',
                  this.file.slice(i * this.chunkSize, (i + 1) * this.chunkSize)
                )

                postData(
                  this.chunkUploadUrl,
                  chunkedFormData,
                  this.accessToken,
                  this.apiKey,
                  this.xIdToken,
                  'formData'
                )
                  .then((response) => {
                    completedCount++ // increment the chunk complete count
                    if (completedCount === this.chunkCount) {
                      this.chunkEndCall()
                    }
                  })
                  .catch((e) => {
                    console.log(e)
                  })
              }
            }, // STEP 3
            // intiated the chunk end call
          },
          {
            key: 'chunkEndCall',
            value: function chunkEndCall() {
              // Meta tag values
              this.statusCallReqParams = {}
              var req = {
                upload_id: this.uploadId,
                file_name: this.name,
                total_number_of_chunks: this.chunkCount,
              }
              if (this.render_job_id !== '') {
                req.render_comment_id = this.render_comment_id
              }
              if (this.asset_id !== '') {
                req.asset_id = this.asset_id
              }
              if (this.asset_type === 'PROP') {
                req.asset_type = this.asset_type
              }

              postData(
                this.endChunkUrl,
                req,
                this.accessToken,
                this.apiKey,
                this.xIdToken
              )
                .then((response) => {
                  // this.initJobStatusCall(response)
                  this.onfileUploadSuccess(response)
                })
                .catch((e) => {
                  console.log(e)
                })
            }, // call jobStatus
          },
          {
            key: 'initJobStatusCall',
            value: function initJobStatusCall(data) {
              this.statusCallReqParams.content_signature =
                data.content_signature
              this.statusCallReqParams.zipped_asset_url =
                data.projected_targets[0].projected_url
              postData(
                this.postUploadProcessUrl,
                this.statusCallReqParams,
                this.accessToken,
                this.apiKey
              )
                .then((response) => {
                  this.onfileUploadSuccess(response)
                })
                .catch((e) => {
                  console.log(e)
                })
            },
          },
        ])

        return ChunkUploader
      })()

    var sceneUploader = null

    onmessage = (e) => {
      if (e.data.action === 'init') {
        e.data.onfileUploadSuccess = (res) => {
          postMessage(res)
        }
        sceneUploader = new ChunkUploader(e.data) // eslint-disable-line no-undef
      } else if (e.data.action === 'process') {
        sceneUploader.initialize(e.data.file)
      }
    }
  }
}
